import React from "react";
import { Typography, Popover, Tag } from "antd";
import { StaticImage } from "gatsby-plugin-image";
import { ExportOutlined } from "@ant-design/icons";
const { Text } = Typography;

const ContentLinkExternalFNT = ({ title, url }) => {
  return (
    <>
      <Popover
        color="#fff"
        placement="topRight"
        content={
          <div>
            <a
              href={url}
              target="_blank"
              rel="noreferrer noopener"
              style={{
                color: "#e00916",
                marginBottom: "24px",
                textDecoration: "underline",
              }}
            >
              <StaticImage
                src="../../../images/logo/logo-fnt.png"
                alt="Logo Federatie Nationale Trombosediensten"
                width={48}
                style={{ marginRight: "8px", top: "-2px" }}
              />
              <span style={{ fontSize: "14px" }}>FNT {"> "}</span>
              {title}
            </a>
            <br />
            <Text style={{ fontSize: "11px", color: "#704f4f" }}>
              <ExportOutlined style={{ transform: "rotate(-90deg)" }} /> opent
              in een nieuw venster
            </Text>
          </div>
        }
        trigger="hover"
      >
        <Tag style={{ margin: "0" }}>
          <Text
            style={{
              textDecoration: "underline",
              textDecorationColor: "#e00916",
            }}
          >
            {title}
            <ExportOutlined
              style={{
                transform: "rotate(-90deg)",
                color: "#e00916",
                marginLeft: "2px",
              }}
            />
          </Text>
        </Tag>
      </Popover>
    </>
  );
};

export default ContentLinkExternalFNT;
